import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { Button, ButtonRow } from '../buttons';
import { Card } from '../card/card';
import { Row, Column } from '../layout';
import { AppText } from '../typography';
import theme from '../../styles/theme';
import { Transition } from 'react-transition-group';
import { AppIcon } from '../icons';
import { transitionStyles, transitionTimeouts } from './incoming_call_notification_transition';
export const LegacyIncomingCallNotification = props => {
    const callButtonStyles = {
        minWidth: '165px',
        alignItems: 'center',
        backgroundColor: theme.colors.white,
        color: theme.colors.grey90,
    };
    const cardStyles = {
        position: 'absolute',
        bottom: '16px',
        left: '16px',
        right: '16px',
        transition: `transform 200ms ease`,
    };
    const nodeRef = useRef(null);
    return (_jsx(Transition, { nodeRef: nodeRef, in: props.open, appear: true, exit: true, unmountOnExit: true, timeout: transitionTimeouts, classNames: "call-notification", onEnter: props.onEnter, onExit: props.onExit, children: state => (_jsx(Card, { className: "call-notification", decoratorPosition: "top", shadow: "xlarge", "data-testid": "incoming-call-notification", animated: true, style: { ...cardStyles, ...transitionStyles[state] }, children: _jsxs(Row, { style: { justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Column, { style: { justifyContent: 'space-between' }, children: _jsxs(AppText, { as: "h2", headingFontFamily: true, size: "xlarge", children: ["Incoming Streem Call from ", props.fromUserName || 'user'] }) }), _jsxs(ButtonRow, { children: [_jsxs(Button, { disabled: props.shouldDisableButtons, variant: "primary", style: {
                                    border: `2px solid ${theme.colors.red50}`,
                                    ...callButtonStyles,
                                }, onClick: props.onReject, children: [_jsx("span", { style: {
                                            transform: 'rotate(135deg)',
                                            marginRight: '8px',
                                            height: '25px',
                                            width: '25px',
                                        }, children: _jsx(AppIcon, { name: "PhoneIconPlain", color: theme.colors.red50 }) }), "Reject"] }), _jsxs(Button, { disabled: props.shouldDisableButtons, variant: "primary", onClick: props.onAnswer, style: {
                                    border: `2px solid ${theme.colors.greenShamrock}`,
                                    ...callButtonStyles,
                                }, children: [_jsx("span", { style: { marginRight: '8px', height: '25px', width: '25px' }, children: _jsx(AppIcon, { name: "PhoneIconCalling", color: theme.colors.greenShamrock }) }), "Answer"] })] })] }) })) }));
};
//# sourceMappingURL=legacy_incoming_call_notification.js.map